module.exports = __webpack_public_path__ + "img/primary_2x4.44c251fe.svg";